import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const ExpertInsightIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props} viewBox="0 0 48 48">
    <title>Expert Insight</title>
    <path d="M8.70588235,4 L8.70588235,39.2941176 L44,39.2941176 L44,44 L4,44 L4,4 L8.70588235,4 Z M44,27.5411765 L44,34.6 L33.4117647,34.6 L33.4117647,27.5411765 L44,27.5411765 Z M40.4705882,15.7764706 L40.4705882,22.8235294 L18.1176471,22.8235294 L18.1176471,15.7764706 L40.4705882,15.7764706 Z M25.1764706,4.01176471 L25.1764706,11.0588235 L13.4117647,11.0588235 L13.4117647,4.01176471 L25.1764706,4.01176471 Z"></path>
  </IconBase>
);
